// extracted by mini-css-extract-plugin
export var orderSummary = "_t6-0";
export var showMoreLessButton = "_t6-1";